import { useMemberGroup } from 'contexts/MemberGroupContext';
import MultiSelectDropdown from './MultiSelectDropdown';

const GroupMembersDropdown = ({ label = "Members", value, onChange, required = false, error = false, multiSelect = true, group_id }) => {
    const { getAvailableMembers } = useMemberGroup();

    const fetchMembers = async (searchValue, page) => {
        try {
            const response = await getAvailableMembers({ page, limit: 50, search: searchValue, group_id, activeOnly: true });
            return {
                options: response.users.map((user) => ({
                    label: `${user.first_name} ${user.last_name}`,
                    value: user.id,
                })),
                hasMore: response.totalPages === 0 ? false : page !== response.totalPages,
            };
        } catch (error) {
            console.error('Error fetching Members:', error);
            return { options: [], hasMore: false };
        }
    };

    return (
        <MultiSelectDropdown
            label={label}
            value={value}
            onChange={onChange}
            fetchData={fetchMembers}
            multiSelect={multiSelect}
            required={required}
            error={error}
        />
    );
};

export default GroupMembersDropdown;
